import { createFileRoute } from "@tanstack/react-router";
import { communicationPreferencesApiRoute } from "@/features/viewer-profile";

export const Route = createFileRoute("/api/user/settings")({
    ...communicationPreferencesApiRoute,
});
